import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import { createElementBlock, openBlock, renderSlot } from "vue";
//#region src/components/SidebarItemDecorator.vue
var _sfc_main = {};
var _hoisted_1 = { class: "absolute top-[1lh] right-0.75 flex -translate-y-1/2 opacity-0 peer-hover/button:opacity-100 peer-focus-visible/button:opacity-100 focus-within:opacity-100 hover:opacity-100 has-[&[aria-expanded=true]]:opacity-100" };
function _sfc_render(_ctx, _cache) {
	return openBlock(), createElementBlock("div", _hoisted_1, [renderSlot(_ctx.$slots, "default")]);
}
var SidebarItemDecorator_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render]]);
//#endregion
export { SidebarItemDecorator_default as default };

//# sourceMappingURL=SidebarItemDecorator.vue.js.map